/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.58"
        height="71.07"
        viewBox="0 0 95.58 71.07"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M54.69 0a1.86 1.86 0 0 1 1.81 1.72v15.77H54v-15H41.5v15H39V1.86A1.85 1.85 0 0 1 40.75 0h13.94Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M60.36 16.24a1.25 1.25 0 0 1 .14 2.49H35.22a1.25 1.25 0 0 1-.13-2.49h25.27Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M40.29 9.43v2.5H7.55a5.07 5.07 0 0 0-5 4.83v46.76a5.05 5.05 0 0 0 4.83 5h80.71a5.06 5.06 0 0 0 5-4.83V17a5.06 5.06 0 0 0-4.83-5H55.3V9.5h32.74a7.55 7.55 0 0 1 7.54 7.3v46.79a7.54 7.54 0 0 1-7.3 7.54H7.55A7.56 7.56 0 0 1 0 63.82V17a7.56 7.56 0 0 1 7.3-7.55h33Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M85.34 31.59a1.25 1.25 0 0 1 .13 2.49H53.85a1.252 1.252 0 0 1-.13-2.5h31.62ZM85.34 41a1.252 1.252 0 0 1 .13 2.5H53.85a1.252 1.252 0 0 1-.13-2.5h31.62ZM85.34 50.48A1.263 1.263 0 0 1 85.5 53H53.85a1.25 1.25 0 0 1-.13-2.49h31.62Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M44.56 42.28A17.16 17.16 0 1 1 27.4 25.13a17.16 17.16 0 0 1 17.16 17.15"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#fff"
          d="M27.4 45.45a18.35 18.35 0 0 1 14.31 6.83 1.25 1.25 0 1 1-1.94 1.57 15.92 15.92 0 0 0-24.74 0 1.271 1.271 0 1 1-2-1.57 18.39 18.39 0 0 1 14.37-6.83Z"/>
        <path
          fill="#fff"
          d="M27.4 30.36a8.8 8.8 0 1 0 8.79 8.8 8.79 8.79 0 0 0-8.79-8.8Zm0 2.5a6.3 6.3 0 1 1-6.29 6.3 6.3 6.3 0 0 1 6.29-6.3Z"/>
      </svg>

    );
  }
}

Icon.displayName = 'IdentificationBadgeIcon';

export default Icon;
